var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0159 0C16.408 0 20.894 3.87976 21.8345 9C20.894 14.1202 16.408 18 11.0159 18C5.62375 18 1.13778 14.1202 0.197266 9C1.13778 3.87976 5.62375 0 11.0159 0ZM11.0159 16C15.2515 16 18.8759 13.052 19.7933 9C18.8759 4.94803 15.2515 2 11.0159 2C6.78023 2 3.15585 4.94803 2.23841 9C3.15585 13.052 6.78023 16 11.0159 16ZM11.0159 13.5C8.53061 13.5 6.51589 11.4853 6.51589 9C6.51589 6.51472 8.53061 4.5 11.0159 4.5C13.5011 4.5 15.5159 6.51472 15.5159 9C15.5159 11.4853 13.5011 13.5 11.0159 13.5ZM11.0159 11.5C12.3966 11.5 13.5159 10.3807 13.5159 9C13.5159 7.6193 12.3966 6.5 11.0159 6.5C9.63523 6.5 8.51589 7.6193 8.51589 9C8.51589 10.3807 9.63523 11.5 11.0159 11.5Z",
    fill: "#20704D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/Eye.e3d10b0f9f0825d32b271acf52ff4716.svg";
export { ForwardRef as ReactComponent };